import React, { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { overlaySetInVisible } from '../../store/reducers/overlayScreenSlice';

interface OverlayProps { 
    children: React.ReactNode;
    isLoading: boolean;
}

const Overlay: React.FC<OverlayProps> = ({ children, isLoading }) => {
    const dispatch = useDispatch();
    const overlayRef = useRef<HTMLDivElement | null>(null);

    const closeOverlayHandler = (e) => {
        // dispatch({ type: overlayScreenActionTypes.OVERLAY_SET_INVISIBLE, payload: { screen: '' } });
        dispatch(overlaySetInVisible());
    };

    useEffect(() => {
        /**
            An effect to detect if the user clicked outside the modal
         */
        const handleClickOutside = (event: MouseEvent) => {
            if (overlayRef.current && !overlayRef.current.contains(event.target as Node)) {
                closeOverlayHandler(event);
            }
        };

        document.body.classList.add('cover-bg');

        // Bind the event listener
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            // Unbind the event listener on clean up
            document.removeEventListener('mousedown', handleClickOutside);
            document.body.classList.remove('cover-bg');
        };
    }, []);

    return (
        <div className={`overlay-main subscribe-popup ${isLoading ? 'loading' : ''}`} style={{ display: 'flex' }}>
            <section className={'overlay-content'} ref={overlayRef}>
                <div className={'overlay-close'} onClick={closeOverlayHandler}>
                    <span className={'icon-close'} />
                </div>
                {children}
            </section>
            {isLoading && (
                <div className={'loader'}>
                    <svg className={'spinner'} viewBox="0 0 50 50">
                        <circle className={'path'} cx="25" cy="25" r="20" fill="none" strokeWidth={'5'} />
                    </svg>
                </div>
            )}
        </div>
    );
};

export default Overlay;
